<template>
  <div class="page-wrapper">
    <search-list @queryData="queryData"></search-list>
    <table-list
      style="margin-top:26px"
      :columns="columns"
      :data="tableDatas"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changePage"
    ></table-list>
    <check :n="checkNum" :fid="fid" @refresh="getsteWarList"></check>
    <img-show :n="imgN" :mediaType="mediaType" :src="imgSrc"></img-show>
  </div>
</template>

<script>
import SearchList from "./components/SearchList";
import TableList from "components/TableList/index";
import Check from "./components/Check";
import { deepClone } from "../../../utils/format";
import ImgShow from "components/ImgListShow/index";
import { formatDateTime } from "../../../utils/format";
import { getsteWarList, updateStatus } from "../../../api/evaluation";

const STATUS_AUDIT = ["待审核", "审核通过", "审核驳回"];
export default {
  components: {
    SearchList,
    TableList,
    Check,
    ImgShow
  },
  data() {
    return {
      loading: false,
      imgSrc: [],
      imgN: 0,
      total: 0,
      fid: "",
      searchData: {},
      mediaType: 0,
      current: 1,
      limit:10,
      page:1,
      checkNum: 0,
      tableDatas: [],
      columns: [
        {
          title: "编号",
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: " "
        },
        {
          title: "管家说内容",
          align: "center",
          key: "impressContent",
          width: 150,
          render: (h, params) => {
            if (params.row.fid && params.row.fid.length > 5) {
              return h(
                "Tooltip",
                {
                  props: {
                    placement: "top"
                  }
                },
                [
                  h(
                    "div",
                    {
                      style: {
                        whiteSpace: "normal"
                      },
                      slot: "content"
                    },
                    params.row.impressContent
                  ),
                  h(
                    "span",
                    { style: { "line-height": "52px!important" } },
                    params.row.impressContent.slice(0, 5) + "..."
                  )
                ]
              );
            } else {
              return h("span", {}, params.row.impressContent);
            }
          }
        },
        {
          title: " "
        },
        {
          title: "附件",
          align: "center",
          key: "",
          width: 100,
          render: (h, params) => {
            if (params.row["picVoList"] && params.row["picVoList"].length > 0) {
              return h(
                "a",
                {
                  on: {
                    click: () => {
                      this.imgSrc = params.row["picVoList"].map(item => {
                        return item.picBaseUrl;
                      });
                      this.mediaType = params.row.mediaType;
                      this.imgN++;
                    }
                  }
                },
                "查看"
              );
            } else {
              return h("span");
            }
          }
        },
        {
          title: " "
        },
        {
          title: "心服务标签",
          align: "center",
          key: "label",
          width: 100
        },
        {
          title: " "
        },
        {
          title: "项目",
          align: "center",
          key: "projectName",
          width: 100
        },
        {
          title: " "
        },
        {
          title: "审批状态",
          align: "center",
          key: "auditStatus",
          width: 100,
          render: (h, params) => {
            return h("span", STATUS_AUDIT[params.row.auditStatus]);
          }
        },
        {
          title: " "
        },
        {
          title: "显隐状态",
          align: "center",
          key: "isShow",
          width: 100,
          render: (h, params) => {
            return h("span", params.row.isShow ? "显示" : "隐藏");
          }
        },
        {
          title: " "
        },
        {
          title: "管家",
          align: "center",
          key: "zoName",
          width: 100
        },
        {
          title: " "
        },
        {
          title: "创建时间",
          align: "center",
          key: "createDate",
          width: 100
        },
        {
          title: " "
        },
        {
          title: "操作",
          align: "center",
          width: 100,
          fixed: "right",
          render: (h, params) => {
            if (params.row.auditStatus === 0) {
              return h(
                "a",
                {
                  directives: [
                    {
                      name: "p",
                      value: {
                        api: "stewarTalk/updateStatus"
                      }
                    }
                  ],
                  on: {
                    click: () => {
                      this.$nextTick(() => {
                        this.fid = params.row.fid;
                        this.checkNum++;
                      });
                    }
                  }
                },
                "审核"
              );
            } else if (params.row.auditStatus === 1) {
              const status = !params.row.isShow ? "显示" : "隐藏";
              return h(
                "a",
                {
                  directives: [
                    {
                      name: "p",
                      value: {
                        api: "stewarTalk/updateStatus"
                      }
                    }
                  ],
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `${status}管家说`,
                        content: `<p>确认${status}本条管家说？</p>`,
                        onOk: () => {
                          const queryData = {
                            fid: params.row.fid,
                            // eslint-disable-next-line no-extra-boolean-cast
                            isShow: +!Boolean(params.row.isShow)
                          };
                          updateStatus(queryData).then(res => {
                            if (res.code === 0) {
                              this.$Message.success("状态切换成功");
                           setTimeout(() => {
                              this.getsteWarList()
                           }, 1000);
                            } else {
                              this.$Message.info(res.message);
                            }
                          });
                        }
                      });
                    }
                  }
                },
                `置为${status}`
              );
            } else if (params.row.auditStatus === 2) {
              return h("span");
            }
          }
        },
        {
          title: " "
        }
      ]
    };
  },

  methods: {
    changePage(n) {
      this.searchData.page = n;
      this.current = n;
      this.getsteWarList();
    },
    queryData(data) {
      this.toatal = 0;
      this.current=1;
      this.page=1;
      this.loading = true;
      data = Object.assign(deepClone(data),{limit:this.limit,page:this.page});
      data["startTime"] = formatDateTime(data.queryTime[0]);
      data["endTime"] = formatDateTime(data.queryTime[1]);
      this.searchData = data;
      this.getsteWarList();
    },
    getsteWarList() {
     
      getsteWarList(this.searchData).then(res => {
        this.loading = false;
        this.tableDatas = res.data.rows;
        this.total = res.data.total;
      });
    }
  }
};
</script>

<style>
</style>